let localDigestKey;

export function getEventMsgInfo(to) {
  if (to.path.indexOf('lives/subscribe') == -1 && to.path.indexOf('lives/watch') == -1) {
    return Promise.resolve();
  }

  localDigestKey = `event_digest_${to.query.projectId}`;
  const localData = localEventData();
  // 如果本地摘要和query中的摘要相同，直接延用本地存储的
  // JSON.parse(sessionStorage.getItem(localDigestKey));
  if (to.query.digest && localData?.digest && to.query.digest === localData.digest) {
    return Promise.resolve();
  }

  // 如果读取本地缓存失败，等待主页面 postMessage 消息
  return new Promise(resolve => {
    window.addEventListener('message', function (event) {
      // console.log(event);
      if (event.data.type === 'eventInfo_cmsToweb') {
        sessionStorage.setItem(localDigestKey, JSON.stringify(event.data));
        resolve();
      }
    });
  });
}

export function localEventData() {
  const localDataStr = sessionStorage.getItem(localDigestKey);
  let localData = {};
  if (localDataStr) {
    try {
      localData = JSON.parse(localDataStr);
    } catch (e) {
      return localData;
    }
  }
  return localData;
}
